<core-preview-page-blur 
    *ngIf="preview != null && preview.status_code == PREVIEW_EXISTS"
    [format]="format" 
    [fileId]="preview.id_file"
    [property]="preview.page_properties[0]"
    [page]="1"
></core-preview-page-blur>
<core-preview-not-found
    *ngIf="preview != null && preview.status_code == PREVIEW_NOT_EXISTS"
></core-preview-not-found>